import { Stack } from 'expo-router';
import React from 'react';

import { VisitorProvider } from '../../user/providers/VisitorProvider';

export default function StartMembershipLayout() {
    return (
        <VisitorProvider>
            <Stack
                screenOptions={{
                    headerShown: false,
                    contentStyle: { backgroundColor: 'transparent' },
                }}
            />
        </VisitorProvider>
    );
}
